import React from "react";
import { ItemType } from "antd/lib/breadcrumb/Breadcrumb";
import { isString, snakeCase } from "lodash-es";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

type CustomBreadcrumb = { path: string; breadcrumbName: string };

type Breadcrumb = keyof typeof breadcrumbToPath | CustomBreadcrumb;

const breadcrumbToPath = {
  settings: {
    path: "/settings",
  },
  settingsBasic: {
    path: "/settings/basic",
  },
  designMappings: {
    path: "/design-mappings",
  },
  inputFormats: {
    path: "/input-formats",
  },
  inputFormatsDataMappings: {
    path: "/input-formats/:inputFormatId/data-mappings",
  },
  libraries: {
    path: "/libraries",
  },
  librariesDesigns: {
    path: "/libraries/designs",
  },
  librariesFonts: {
    path: "/libraries/fonts",
  },
  librariesColorsEmbroidery: {
    path: "/libraries/colors/embroidery",
  },
  librariesColorCollectionsEmbroidery: {
    path: "/libraries/color-collections/embroidery",
  },
  librariesFontCollectionsEmbroidery: {
    path: "/libraries/font-collections/embroidery",
  },
  logs: {
    path: "/logs",
  },
};

export const useBreadcrumb = (...breadcrumbs: Breadcrumb[]) => {
  const { t } = useTranslation();

  const items = breadcrumbs.map((b) => {
    return isString(b)
      ? {
          ...breadcrumbToPath[b],
          breadcrumbName: t(`main_menu.${snakeCase(b)}`),
        }
      : (b as CustomBreadcrumb);
  });

  const itemRender: (item: ItemType) => React.ReactNode = (item: ItemType) => {
    if (!item.path) {
      return item.breadcrumbName;
    }

    return <Link to={item.path}>{item.breadcrumbName}</Link>;
  };

  return { items, itemRender };
};
